export default {
  namespaced: true,
  state: {
    // 用户信息
    userInfo: sessionStorage.getItem('userInfo') || '',
    // 企业信息
    companyInfo: sessionStorage.getItem('companyInfo') || '',
    percentage: 0,
    companyMember: sessionStorage.getItem('companyMember') || false,
    isFreeze: sessionStorage.getItem('isFreeze')  || false,
  },
  mutations: {
    // 上传文件进度条
    setPercentage(state, payload) {
      state.percentage = payload
    },
    // 保存用户名
    setUserInfo(state, data) {
      state.userInfo = data
      sessionStorage.setItem('userInfo', data)
    },
    // 保存企业ID
    setCompanyInfo(state, data) {
      state.userInfo = data
      sessionStorage.setItem('companyInfo', data)
    },
    // 企业是否为会员
    setCompanyMember(state, data) {
      state.companyMember = data
      sessionStorage.setItem('companyMember', data)
    },

    // 企业是否冻结
    setIsFreeze(state, data) {
      state.isFreeze = data
      sessionStorage.setItem('isFreeze', data)
    },

    // 清空实名认证本地存储数据
    clearLocalStorage(state) {
      state.userName = ''
      state.idCardNumber = ''
      state.identificationIDNumber = ''
      state.identityUserName = ''
      state.userId = ''
      state.businessType = ''
      sessionStorage.removeItem('userName')
      sessionStorage.removeItem('idCardNumber')
      sessionStorage.removeItem('identificationIDNumber')
      sessionStorage.removeItem('identityUserName')
      sessionStorage.removeItem('userId')
      sessionStorage.removeItem('businessType')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/login.js